import request from '../../utils/request';

const getParams = (endpoint, payload) =>
  request({
    url: `/params/${endpoint}`,
    method: 'GET',
    params: payload,
  });

export default {
  getParams,
};
